import React from "react";
import InputTooltip, { placement } from "@/components/general/tooltip";
import styles from "@/components/forms/inputsWithRef/textAreaWithRef.module.css";
import classNames from "classnames";

interface Props {
  style?: React.CSSProperties;
  mandatory?: boolean;
  label?: string | any;
  name?: string;
  readonly?: boolean;
  required?: boolean;
  rows?: number;
  cols?: number;
  value?: any;
  defaultValue?: string;
  onChange?: (event: any) => void;
  onBlur?: (event: React.FocusEvent<HTMLTextAreaElement>) => void;
  disabled?: boolean;
  placeholder?: string;
  fieldStyle?: React.CSSProperties;
  tooltip?: boolean;
  placement?: placement;
  tooltipMessage?: any;
  type?: any;
  wrapperClassname?: any;
  labelClassname?: any;
  labelRightSlot?: React.ReactNode;
  hideLabel?: boolean;
}

export const TextAreaWithRef = React.forwardRef<HTMLTextAreaElement, Props>(
  function TextAreaWithRef(props, ref) {
    return (
      <div
        className={classNames({
          [props.wrapperClassname]: props.wrapperClassname,
        })}
      >
        {!props.hideLabel && (
          <div
            className={classNames(styles.label, {
              [props.labelClassname]: props.labelClassname,
            })}
          >
            <label className={styles.labelText} htmlFor={props.name}>
              {props.label}
              {(props.mandatory === true || props.required === true) && (
                <span className={styles.labelRequired}>*</span>
              )}
              {props.tooltip && (
                <InputTooltip
                  tooltipMessage={props.tooltipMessage}
                  placement={props.placement}
                />
              )}
            </label>
            {props.labelRightSlot && (
              <span className={styles.labelRightSlot}>
                {props.labelRightSlot}
              </span>
            )}
          </div>
        )}
        <textarea
          ref={ref}
          name={props.name}
          id={props.name}
          readOnly={props.readonly}
          // required={props.required}
          rows={props.rows !== undefined ? props.rows : 4}
          cols={props.cols}
          defaultValue={props.defaultValue}
          onChange={(event: any) => props.onChange?.(event)}
          onBlur={props.onBlur}
          disabled={props.disabled}
          placeholder={props.placeholder}
          style={props.fieldStyle}
          className={`${styles.textArea} ${
            props.cols !== undefined ? styles.textAreaWithCustomWidth : ""
          }`}
          {...(props.value !== null && props.value !== undefined
            ? { value: props.value }
            : {})}
        />
      </div>
    );
  }
);
